import * as i0 from "@angular/core";
export class WarningBoxStore {
}
WarningBoxStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WarningBoxStore_Factory() { return new WarningBoxStore(); }, token: WarningBoxStore, providedIn: "root" });
export var WarningBoxStoreKeys;
(function (WarningBoxStoreKeys) {
})(WarningBoxStoreKeys || (WarningBoxStoreKeys = {}));
